module.exports = __webpack_public_path__ + "media/img/clients-modal/bridebook-810a25502ebe71ab088aa1c44e7893fe.svg";